import {mapRecordToItems} from '@/helpers/mapRecordToItems.helper';

export enum TimetableCancellationReason {
    VACANCY = 'VACANCY',
    HOLIDAY = 'HOLIDAY',
    /** Original of a lesson that was moved once to another date (only emitted with includeMovedOrigins) */
    MOVED = 'MOVED',
}

export namespace TimetableCancellationReason {
    type Data = {
        text: string;
    }

    export const Record: Record<TimetableCancellationReason, Data> = {
        [TimetableCancellationReason.VACANCY]: {
            text: 'Keine Lehrkraft',
        },
        [TimetableCancellationReason.HOLIDAY]: {
            text: 'Ferien',
        },
        [TimetableCancellationReason.MOVED]: {
            text: 'Verschoben',
        },
    }

    export const items = mapRecordToItems(Record);
}
